import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TicketArtSelectPageRoutingModule } from './ticket-art-select-routing.module';

import { TicketArtSelectPage } from './ticket-art-select.page';
import { ComponentsModule } from '../../../../components/components.module'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    TicketArtSelectPageRoutingModule
  ],
  declarations: [TicketArtSelectPage]
})
export class TicketArtSelectPageModule {}
